export const openPrintWindow = (title, subtitle, headers, rows) => {
  sessionStorage.setItem("reportPrintData", JSON.stringify({ title, subtitle, headers, rows }));
  window.open("/report-print", "_blank");
};
